import { mergeAttributes, Node } from '@tiptap/core'
import type { ColumnHTMLAttributesOptions } from '#src/tiptap/nodes/shared.ts'

export const ColumnNode = Node.create<ColumnHTMLAttributesOptions>({
  name: 'column',
  group: 'column',
  content: 'block+',
  defining: true,
  isolating: true,
  addOptions() {
    return { HTMLAttributes: {} }
  },
  addAttributes() {
    return {
      width: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-width'),
        renderHTML: (attributes: Record<string, string>) =>
          attributes.width ? { 'data-width': attributes.width } : {},
      },
    }
  },
  parseHTML() {
    return [{ tag: `div[data-type="${this.name}"]` }]
  },
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(
        HTMLAttributes,
        { 'data-type': this.name },
        this.options.HTMLAttributes
      ),
      0,
    ]
  },
})
